import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CraftLogo, LangSwitcher, CraftFooter } from "../components/Shared";
import { useLang } from "../i18n";
import { LEGAL_DOCS } from "../constants/legalDocs";

export default function Legal() {
  const { doc } = useParams();
  const { L } = useLang();
  const d = LEGAL_DOCS[doc] || LEGAL_DOCS.privacy;
  return (
    <div className="min-h-screen bg-[#FBF3E4]">
      <div className="max-w-[430px] mx-auto min-h-screen flex flex-col">
        <div className="flex items-center justify-between px-5 pt-5 pb-3"><CraftLogo /><LangSwitcher /></div>
        <div className="px-5 flex-1">
          <Link to="/loyalty" className="inline-flex items-center gap-1 text-sm font-bold text-gray-500 mb-3" data-testid="legal-back"><ArrowLeft size={16} /> CRAFT</Link>
          <div className="craft-card p-6">
            <h1 className="font-display font-black text-xl mb-3" data-testid="legal-title">{L(d.title)}</h1>
            <p className="text-sm text-gray-600 leading-relaxed whitespace-pre-line">{L(d.body)}</p>
          </div>
        </div>
        <CraftFooter />
      </div>
    </div>
  );
}
